import basePath from "base_path";
import ActionTypes, {ProjectActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId, ProjectIssueOverrideTag} from "common/types/project";

export type IssueOverrideTagAddAction = {
  type: ProjectActionTypes["PROJECT_ADD_ISSUE_OVERRIDE_TAG"]["SUCCESS"];
  payload: ProjectIssueOverrideTag[];
};

export default function addIssueOverrideProjectTag(requestor) {
  return createReduxPromiseAction(
    ActionTypes.PROJECT_ADD_ISSUE_OVERRIDE_TAG,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      name?: string,
      tagId?: string,
    ) => {
      return requestor
        .post(
          `${basePath}/organisation/${organisationId}/project/${projectId}/issue_override_tag`,
          {name, tagId},
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
